
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web3",
      function () {
        return require("private-next-pages/web3.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web3"])
      });
    }
  